import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs2/helpers/esm/slicedToArray";
import _Object$entries from "@babel/runtime-corejs2/core-js/object/entries";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
export var getAudiences = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var cachedAudiences, audiences;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!window.utag || !window.utag.data)) {
              _context.next = 3;
              break;
            }

            _context.next = 3;
            return waitForTealium();

          case 3:
            cachedAudiences = sessionStorage && JSON.parse(sessionStorage.getItem('liveperson_audiences') || '[]') || [];
            audiences = _Object$entries(window.utag.data).filter(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 1),
                  key = _ref3[0];

              return key.startsWith('va.audiences');
            }).map(function (_ref4) {
              var _ref5 = _slicedToArray(_ref4, 2),
                  _ = _ref5[0],
                  value = _ref5[1];

              return value;
            });
            return _context.abrupt("return", [].concat(_toConsumableArray(cachedAudiences), _toConsumableArray(audiences)));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getAudiences() {
    return _ref.apply(this, arguments);
  };
}();

function waitForTealium() {
  return new _Promise(function (resolve) {
    var interval = setInterval(function () {
      if (window.utag) {
        resolve();
        clearInterval(interval);
      }
    }, 50);
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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